import { useEffect, useRef, useState } from 'react';
import { TabType } from './tabs';

export interface ActiveTabStyles {
  left: number;
  width: number;
}

export const useSetActiveTabData = (activeTab: TabType) => {
  const ref = useRef<HTMLUListElement>(null);
  const [activeTabData, setActiveTabData] = useState<ActiveTabStyles>({ left: 0, width: 0 });

  useEffect(() => {
    const shift = ref.current?.getBoundingClientRect().left || 0;

    if (typeof document === 'undefined' || !activeTab) {
      return;
    }
    const el = document.getElementById(`${activeTab.label}-${activeTab.id}`);
    
    if (el) {
      const { left, width } = el.getBoundingClientRect();
      setActiveTabData({ left: left - shift, width });
    }
  }, [activeTab]);

  return { activeTabData, ref };
};
